import { Pipe, PipeTransform } from '@angular/core';
import { hebrewDaysInitials } from '../constants/hebrew-days';

@Pipe({
  name: 'hebrewDayName'
})
export class HebrewDayNamePipe implements PipeTransform {
  days = hebrewDaysInitials;

  transform(value: number): string {
    return hebrewDaysInitials[value];
  }
}
